/** Campos de texto que la barra de Estimates debe cruzar. */
export const ESTIMATE_SEARCH_FIELDS = [
  "DiseñoMuestra",
  "designCliente",
  "NombrePresupuesto",
  "NumeroPresupuesto",
  "ClienteNombre",
  "MarcaNombre",
  "ProyectoNombre",
  "ProveedorNombre",
  "TemporadaNombre",
  "Notas",
  "TipoPrenda",
  "ABREVIATURA",
  "PresupuestoEstado",
  "Estado",
  "IncotermNombre",
  "StatusMilestone",
];

function fieldText(value) {
  if (value == null) return "";
  if (typeof value === "string") return value;
  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  return "";
}

/**
 * ¿El presupuesto coincide con el término de búsqueda (incl. Notas)?
 */
export function estimateMatchesSearchTerm(item, searchTerm) {
  const term = String(searchTerm || "")
    .trim()
    .toLowerCase();
  if (!term) return true;
  if (!item || typeof item !== "object") return false;

  for (const key of ESTIMATE_SEARCH_FIELDS) {
    if (fieldText(item[key]).toLowerCase().includes(term)) return true;
  }

  // Resto de strings del row (por si el API añade más columnas)
  return Object.values(item).some((value) => {
    if (typeof value !== "string") return false;
    return value.toLowerCase().includes(term);
  });
}
